const comparisonOptionNames = {
  none: 'Keiner',
  lastYear: 'Vorheriges Jahr',
  lastMonth: 'Vorheriges Monat',
  lastWeek: 'Vorherige Woche',
  sameRange: 'Vorheriger Zeitraum',
  identical: 'Gleicher Zeitraum',
  custom: 'Benutzerdefiniert',
};

export default comparisonOptionNames;
